var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobotLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 488,
    viewBox: "0 0 377 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.32 487.227C163.314 487.227 143.962 484.563 143.962 477.227C143.962 469.89 163.314 467.227 176.32 467.227C189.327 467.227 208.679 469.89 208.679 477.227C208.679 484.563 189.327 487.227 176.32 487.227ZM176.32 470.148C156.695 470.148 146.43 474.758 146.43 477.227C146.43 479.696 156.695 484.306 176.32 484.306C195.945 484.306 206.21 479.696 206.21 477.227C206.21 474.758 195.945 470.148 176.32 470.148Z",
    fill: "url(#paint0_linear_2601_14)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.075 480.812C184.317 480.812 190.188 479.207 190.188 477.227C190.188 475.247 184.317 473.642 177.075 473.642C169.832 473.642 163.961 475.247 163.961 477.227C163.961 479.207 169.832 480.812 177.075 480.812Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M376.037 135.193L208.881 457.986L207.354 460.93L205.325 464.848L201.77 471.713L199.19 476.692C199.19 480.013 189.688 482.709 177.748 482.878C177.363 482.886 176.979 482.886 176.586 482.886C164.1 482.886 153.983 480.117 153.983 476.692L151.617 471.626L146.882 461.481L145.267 458.018L143.238 453.677L133.29 432.36L116.153 395.656L96.8467 354.292L94.92 350.158L73.5875 304.445L60.0265 275.395L0 146.792C13.8937 134.222 46.3153 107.008 93.5755 88.285C100.596 85.4992 107.94 82.9044 115.61 80.5743C117.38 80.0313 119.17 79.5047 120.982 78.9945C122.34 78.6125 123.705 78.2359 125.078 77.8785C126.159 77.5838 127.254 77.3028 128.349 77.0245H128.363C144.71 72.8908 162.346 70.0259 181.165 69.0845C183.429 68.9645 185.714 68.8772 188.017 68.8199C223.953 67.9249 255.963 74.2796 283.175 83.5838C284.095 83.8867 285.007 84.2059 285.906 84.5251C286.169 84.6206 286.433 84.7079 286.689 84.8034C289.588 85.8321 292.432 86.9017 295.216 87.9958C302.831 90.9808 310.015 94.1649 316.745 97.4364C345.14 111.234 365.472 126.623 376.035 135.193H376.037Z",
    fill: "url(#paint1_linear_2601_14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.838 22.5934C141.779 32.6746 136.573 41.9121 128.297 46.5953L129.823 62.9507C131.219 62.9107 132.636 62.8906 134.073 62.8906L222.696 71.8528C227.852 72.5721 232.795 73.2075 237.527 73.8157C293.609 81.0246 319.998 84.4166 319.998 178.539C319.998 212.62 293.195 240.249 260.13 240.249H95.0441C61.9805 240.249 48.3623 198.192 48.3623 164.11C48.3623 109.623 65.6453 74.4356 109.195 65.2739L107.616 48.3511C98.8109 45.1805 92.1694 37.1556 91.2424 27.2212C89.9645 13.5257 100.031 1.38732 113.726 0.109389C127.422 -1.16855 139.56 8.89787 140.838 22.5934Z",
    fill: "url(#paint2_radial_2601_14)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5269 290.977C106.171 335.739 141.516 370.2 157.473 372.601C174.135 375.108 198.022 375.938 215.42 372.601C232.819 369.264 263.931 337.656 278.925 290.977C291.323 252.381 261.008 250.957 238.904 250.957H183.726H128.548C106.444 250.957 76.6221 260.775 88.5269 290.977Z",
    fill: "url(#paint3_linear_2601_14)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.469 211.092H129.789C112.215 211.092 97.7964 193.812 97.7964 172.494V139.808C97.7964 118.492 112.215 101.802 129.789 102.52L259.469 114.385C274.871 114.385 287.745 134.389 287.745 154.196V175.223C287.745 195.032 275.164 211.089 259.469 211.089V211.092Z",
    fill: "url(#paint4_linear_2601_14)",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.282 218.882L183.297 219.223C176.262 219.002 170.944 212.653 171.631 204.985L172.363 196.804C172.679 193.285 175.635 190.678 178.921 190.99L224.102 193.922C226.716 194.17 228.505 196.869 228.131 199.944L227.26 207.097C226.442 213.809 221.15 219.067 215.282 218.882Z",
    fill: "url(#paint5_linear_2601_14)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.066 144.614C180.45 162.837 165.178 176.174 147.816 174.388C130.297 172.588 117.31 156.098 118.952 137.576C120.595 119.055 136.221 105.756 153.716 107.858C171.052 109.94 183.683 126.388 182.067 144.611L182.066 144.614Z",
    fill: "url(#paint6_radial_2601_14)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.987 148.118C265.474 165.175 251.25 177.665 235.086 176.001C218.777 174.324 206.693 158.895 208.23 141.559C209.768 124.223 224.322 111.769 240.609 113.729C256.748 115.67 268.5 131.059 266.987 148.115L266.987 148.118Z",
    fill: "url(#paint7_radial_2601_14)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.518 143.301C169.514 154.623 159.889 162.902 148.937 161.783C137.888 160.654 129.687 150.409 130.707 138.908C131.727 127.407 141.569 119.152 152.602 120.46C163.54 121.758 171.522 131.979 170.518 143.301Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.345 146.906C255.402 157.54 246.391 165.319 236.141 164.272C225.801 163.214 218.128 153.594 219.086 142.791C220.044 131.989 229.258 124.232 239.583 125.458C249.82 126.673 257.288 136.271 256.345 146.906Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.316 146.066C165.763 152.293 160.431 156.843 154.359 156.224C148.233 155.598 143.683 149.96 144.244 143.634C144.805 137.309 150.258 132.772 156.374 133.496C162.439 134.214 166.868 139.839 166.316 146.066Z",
    fill: "#FCAE00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.238 149.583C251.72 155.426 246.777 159.701 241.154 159.126C235.481 158.546 231.273 153.261 231.799 147.325C232.326 141.39 237.381 137.127 243.045 137.8C248.661 138.467 252.757 143.74 252.238 149.583Z",
    fill: "#FCAE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M218.703 222.332C202.311 201.652 209.595 185.114 188.166 157.089C158.682 118.527 124.285 122.89 116.405 96.7368C114.221 89.4904 105.086 79.3726 110.942 65.6232C57.6454 77.886 48.5098 118.923 48.5098 171.627C48.5098 210.462 71.9539 238.547 90.3849 238.547H237.538C229.27 233.708 223.236 228.054 218.701 222.334L218.703 222.332Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.848,
    cy: 25.3419,
    r: 7.73583,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.74 122.956C80.6738 104.627 96.3177 95.7706 103.648 93.6335C103.648 84.9718 106.295 68.369 111.843 64.7843C110.23 64.7843 105.83 66.5465 100.282 68.2656C61.9132 80.1542 44.8111 124.129 48.3624 175.608C51.2034 216.792 77.183 238.868 89.7947 239.748H132.997C146.778 239.748 127.716 237.498 103.95 232.671C74.2416 226.636 71.8228 145.867 76.74 122.956Z",
    fill: "url(#paint8_linear_2601_14)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.995 282.272C144.43 302.747 150.838 318.484 156.294 327.921C166.756 346.018 189.124 353.724 198.586 357.41C208.048 361.097 210.702 360.802 221.318 370.533C215.125 373.63 208.785 373.187 202.74 374.219L181.36 374.514L161.602 373.187L156.441 372.303C141.697 370.681 96.8891 326.246 86.4039 282.272C80.6357 258.081 117.368 249.331 132.186 250.953H198.586C194.869 251.963 191.114 253.144 187.331 254.54C182.909 256.172 152.165 268.057 148.995 282.272Z",
    fill: "url(#paint9_linear_2601_14)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M186.226 258.915C221.486 258.915 250.07 256.605 250.07 253.754C250.07 250.904 221.486 248.594 186.226 248.594C150.965 248.594 122.381 250.904 122.381 253.754C122.381 256.605 150.965 258.915 186.226 258.915Z",
    fill: "#AE60D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2601_14",
    x1: 176.415,
    y1: 458.359,
    x2: 176.415,
    y2: 493.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C74FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DEC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2601_14",
    x1: 176.132,
    y1: 43.17,
    x2: 188.018,
    y2: 482.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF1EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF1EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2601_14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.994 157.348) rotate(120.947) scale(111.14 180.689)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86F1E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2601_14",
    x1: 85.814,
    y1: 375.992,
    x2: 306.985,
    y2: 258.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DD1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB79EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2601_14",
    x1: 97.7943,
    y1: 156.795,
    x2: 287.745,
    y2: 156.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2601_14",
    x1: 226.892,
    y1: 210.1,
    x2: 157.541,
    y2: 217.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45F90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2601_14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.509 141.094) rotate(95.0681) scale(33.4043 31.7445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAE00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2601_14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.609 144.838) rotate(95.0681) scale(31.2665 29.5532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2601_14",
    x1: 39.7248,
    y1: 251.087,
    x2: 190.682,
    y2: 95.1284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DEC4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2601_14",
    x1: 85.8139,
    y1: 286.341,
    x2: 167.205,
    y2: 313.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82AFED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotLarge);
export default __webpack_public_path__ + "static/media/robot-large.29963e567d5ebacbaf18309d3ae7f0dc.svg";
export { ForwardRef as ReactComponent };